export const GroupQcFieldName = 'groupQcFieldComponent';
